import React from "react";
import './component.css'
const FooterLink=()=>{
    return(<div style={{height:"auto"}} >
        <div className="FooterLinkContainer">
            <ul className="footerLinks">
                <a href="https://www.about.vsam.me/" className="tdn">Vsamer</a>
                <a href="https://www.about.vsam.me/"  className="tdn">About Us</a>
                <a href="https://www.investors.vsam.me/"   className="tdn">Investors</a>
                <a href="https://www.investors.vsam.me/" className="tdn" >Blog</a>
                <a href="https://www.contact.vsam.me/" className="tdn">Contact Us</a>
                <a href="https://www.about.vsam.me/" className="tdn">Advertisement</a>
                <a href="https://www.about.vsam.me//" className="tdn">Sponsors</a>
                <a href="https://www.about.vsam.me/" className="tdn">Bussiness</a>
                <a href="https://www.about.vsam.me/" className="tdn">Privacy Policy</a>
                <a href="https://www.about.vsam.me/" className="tdn">Disclaimer</a>
                <a  href="https://www.about.vsam.me/" className="tdn">Career</a> 
                <a  href="https://www.about.vsam.me/" className="tdn">Career</a> 
                <a  href="https://www.about.vsam.me/" className="tdn">News Room</a> 
                <a  href="https://www.about.vsam.me/" className="tdn">v Tick</a> 
                <a  href="https://www.about.vsam.me/" className="tdn">Vsam Badges</a> 
            </ul>
        </div>
        <div style={{color:"var(--primary-text-color)",textAlign:"center"}}>
        © 2021 VSAM Networks All Rights Reserved
        </div>
</div>
    )
}

export default FooterLink
